import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <main className="relative flex flex-col items-center justify-center min-h-screen bg-background-50 px-4 text-center">
      {/* Background 404 watermark */}
      <span className="absolute bottom-0 text-9xl md:text-[12rem] font-heading font-bold text-background-100 select-none pointer-events-none z-0">
        404
      </span>

      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-3">
          Strona nie została znaleziona
        </h1>
        <p className="text-sm text-foreground-500 font-mono mb-6">{location.pathname}</p>
        <p className="text-base text-foreground-600 mb-8">
          Przepraszamy, strona której szukasz nie istnieje lub została przeniesiona.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i>
          Powrót do strony głównej
        </Link>
      </div>
    </main>
  );
}